module.exports = __webpack_public_path__ + "static/img/5.d9404a81.png";